import { BaseAction } from "../base/base.action";

export class SubsciptionAction extends BaseAction {
    constructor() {
        super("SUBSCRIPTION")
    }
}


